
export const authHandler = config => {
  // const token = Cache.get('loginToken') || ''
    const token = '';
    config.headers['Authorization'] = token;
}
